document.addEventListener('DOMContentLoaded', function () {
    const searchInput = getElement('search-input');
    const searchResultsContainer = getElement('search-results');
    const searchCategoryProduct = getElement('search-category-product');
    const searchCategoryCollection = getElement('search-category-collection');
    const searchResultsProductContainer = getElement('product-results-container');
    const searchResultsCollectionContainer = getElement('collection-results-container');

    function debounce(func, delay) {
        let timeout;
        return function (...args) {
            clearTimeout(timeout);
            timeout = setTimeout(() => func.apply(this, args), delay);
        };
    }

    searchCategoryProduct.addEventListener('click', function (event) {
        toggleClass(searchCategoryProduct, 'underline', true);
        toggleClass(searchCategoryProduct, 'font-medium', true);
        toggleClass(searchCategoryCollection, 'underline', false);
        toggleClass(searchCategoryCollection, 'font-medium', false);
        toggleClass(searchResultsProductContainer, 'hidden', false);
        toggleClass(searchResultsProductContainer, 'flex', true);
        toggleClass(searchResultsCollectionContainer, 'hidden', true);
        toggleClass(searchResultsCollectionContainer, 'flex', false);
    });

    searchCategoryCollection.addEventListener('click', function (event) {
        toggleClass(searchCategoryProduct, 'underline', false);
        toggleClass(searchCategoryProduct, 'font-medium', false);
        toggleClass(searchCategoryCollection, 'underline', true);
        toggleClass(searchCategoryCollection, 'font-medium', true);
        toggleClass(searchResultsProductContainer, 'hidden', true);
        toggleClass(searchResultsProductContainer, 'flex', false);
        toggleClass(searchResultsCollectionContainer, 'hidden', false);
        toggleClass(searchResultsCollectionContainer, 'flex', true);
    });

    // Debounced search input handler
    const handleSearchInput = debounce(function (event) {
        const query = event.target.value.trim();

        fetch(
            `/search/suggest.json?q=${query}&resources[type]=product,collection&resources[options][unavailable_products]=hide&resources[options][fields]=title,product_type,variants.title`
        )
            .then((response) => response.json())
            .then((suggestions) => {
                const productSuggestions = suggestions.resources.results.products;
                const collectionSuggestions = suggestions.resources.results.collections;

                searchResultsProductContainer.innerHTML = '';
                searchResultsCollectionContainer.innerHTML = '';

                if (productSuggestions.length > 0 || collectionSuggestions.length > 0) {
                    if (productSuggestions.length > 0) {
                        toggleClass(searchCategoryProduct, 'hidden', false);
                        toggleClass(searchCategoryProduct, 'underline', true);
                        toggleClass(searchCategoryProduct, 'font-medium', true);

                        productSuggestions.forEach((product) => {
                            const productElement = document.createElement('a');
                            productElement.classList.add('flex', 'gap-6');
                            productElement.href = product.url;

                            const imgElement = document.createElement('img');
                            imgElement.src = product.image;
                            imgElement.width = 400;
                            imgElement.height = 400;
                            imgElement.classList.add('max-w-24', 'min-w-24', 'max-h-24', 'min-h-24', 'object-cover', 'rounded-lg', 'overflow-hidden');
                            productElement.appendChild(imgElement);

                            const infoElement = document.createElement('div');
                            infoElement.classList.add('flex-grow', 'flex', 'flex-col', 'gap-1', 'justify-center', 'items-start');

                            const titleElement = document.createElement('span');
                            titleElement.classList.add('font-medium', 'md:text-base', 'text-sm');
                            titleElement.textContent = product.title;
                            infoElement.appendChild(titleElement);

                            const priceElement = document.createElement('span');
                            priceElement.classList.add('text-xs');
                            priceElement.textContent = product.price;
                            infoElement.appendChild(priceElement);

                            productElement.appendChild(infoElement);

                            searchResultsProductContainer.appendChild(productElement);
                        });

                        toggleClass(searchResultsProductContainer, 'hidden', false);
                        toggleClass(searchResultsProductContainer, 'flex', true);
                    } else {
                        toggleClass(searchCategoryProduct, 'hidden', true);
                        toggleClass(searchCategoryProduct, 'underline', false);
                        toggleClass(searchCategoryProduct, 'font-medium', false);
                    }

                    if (collectionSuggestions.length > 0) {
                        toggleClass(searchCategoryCollection, 'hidden', false);

                        collectionSuggestions.forEach((collection) => {
                            const collectionElement = document.createElement('a');
                            collectionElement.classList.add('flex', 'gap-6', 'py-2', 'border-b');
                            collectionElement.href = collection.url;

                            const titleElement = document.createElement('span');
                            titleElement.classList.add('font-medium');
                            titleElement.textContent = collection.title;
                            collectionElement.appendChild(titleElement);

                            searchResultsCollectionContainer.appendChild(collectionElement);
                        });

                        if (productSuggestions.length === 0) {
                            toggleClass(searchCategoryCollection, 'underline', true);
                            toggleClass(searchCategoryCollection, 'font-medium', true);
                            toggleClass(searchResultsCollectionContainer, 'hidden', false);
                            toggleClass(searchResultsCollectionContainer, 'flex', true);
                        }
                    } else {
                        toggleClass(searchCategoryCollection, 'hidden', true);
                        toggleClass(searchCategoryCollection, 'underline', false);
                        toggleClass(searchCategoryCollection, 'font-medium', false);
                    }
                }
            });
    }, 300);

    searchInput.addEventListener('input', handleSearchInput);
});